import CrudReducer from './crudReducer';

const cr = new CrudReducer('designation');

const reducer = cr.Reducer;

export default reducer;
